import * as React from "react";
import { useEffect, useState, useContext } from "react";

import {
  DataGrid,
  GridCellEditCommitParams,
  GridColumns,
  GridColumnVisibilityModel,
  GridRenderCellParams,
  GridRowId,
  GridRowsProp,
  GridSelectionModel,
  MuiBaseEvent,
  MuiEvent,
} from "@mui/x-data-grid";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Navigate, useNavigate } from "react-router-dom";
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";
/* Localização */
/*
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
*/
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import br from "date-fns/locale/pt-BR";

/* Meus Componentes */
import { hasInCache } from "../../helper/cacheHelper";

import PageHelper from "../../helper/pageHelper";

/* Componentes */
import Button from "@mui/material/Button";
import FileUpload from "../../components/common/FileUpload";

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Download from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import { confirmAlert } from "react-confirm-alert";

/* LOCALIZAÇÃO */

import { format } from "date-fns";
import { pt } from "date-fns/locale";
import PedidoImportacaoDataset from "../../components/data/PedidoImportacaoDataSet";
import UnidadeArmazenamento from "../../components/classes/UnidadeArmazenamento";
import Parceiro from "../../components/classes/Parceiro";

import SaveIcon from "@mui/icons-material/Save";
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  InputLabel,
  Modal,
  OutlinedInput,
  Tooltip,
} from "@mui/material";
import { Send } from "@mui/icons-material";
import ShareIcon from '@mui/icons-material/Share';
import PedidosImportacaoTopo from "./PedidosImportacaoTopo";
import PedidoImportacao from "../../components/classes/PedidoImportacao";
import AutocompleteJustificativaPI from "../../components/common/AutocompleteJustificativaPI";
import SkuDescricao from "../../components/common/SkuDescricao";
import { UserContext } from "../../App";
import HistoricoPedidoImportacaoModal from "./historicoPedidoImportacaoModal/historicoPedidoImportacaoModal";
import Utils from "../../helper/utils";
import AutocompleteJustificativaCommon from "../../components/common/AutocompleteJustificativaCommon";

import styles from './detail.module.css';
import Usuario from "../../components/classes/Usuario";
import UsuarioDataset from "../../components/data/UsuarioDataSet";
import ConfigurationModal from "./configurationModal/configurationModal";

import { useTranslation } from "react-i18next";

interface Data {
  id: number;
  bookingStatus: string;
  sequenciaInstrucaoEmbarque: string;
  sequenciaDoEmbarque: string;
  documentoCompra: string;
  item: number;
  codigoFornecedorSap: number;
  nomeFornecedorSap?: string;
  idSku: number;
  skuDescricao?: string;
  quantidadePedido: number;
  quantidadeEmbarque: number;
  unidadeMedida: string;
  dataRemessaEstatistica: Date | null;
  dataRemessa: Date | null;
  etd: Date | null;
  eta: Date | null;
  entradaEstoque: Date | null;
  dataRegistroDes: Date | null;
  previsaoEntradaEstoque: Date;
  mes: number | null;
  semana: number | null;
  desvioRecebimento: number;
  justificativa: string;
  justificativaDescricao?: string;
  causador: string;
  observacao: string;
  sigla: string;
}

interface PedidosImportacaoFilters {
  bookingStatus?: string;
  pedido?: number;
  material?: number;
  instrucaoEmbarque?: string;
}

function PedidosImportacao(param: any) {
  const { t } = useTranslation();

  const user: any = useContext(UserContext);
  const [loading, setLoading] = React.useState(false);
  const [pageSize, setPageSize] = React.useState(25);
  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState<GridColumnVisibilityModel>({});
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const [open, setOpen] = React.useState(false);
  const [filterOpen, setFilterOpen] = React.useState(false);
  const [idsSelecionados, setIdsSelecionados] = React.useState<GridRowId[]>([]);
  const hasIdSelecionado: boolean = React.useMemo(
    () => idsSelecionados && idsSelecionados.length > 0,
    [idsSelecionados]
  );
  const [pedidosImportacao, setPedidosImportacao] = React.useState<
    PedidoImportacao[]
  >([]);
  const dataPedidoImportacao: PedidoImportacaoDataset = new PedidoImportacaoDataset();
  const dataUsuario: UsuarioDataset = new UsuarioDataset();

  const [rows, setRows] = React.useState<Data[]>([]);
  const navigate = useNavigate();

  const [filterValues, setFilterValues] =
    React.useState<PedidosImportacaoFilters>({});

  const [openDownloadCSVModal, setOpenDownloadCSVModal] = useState<boolean>(false);
  const [openFileDialog, setOpenFileDialog] = useState<boolean>(false);
  const [showConfigModal, setShowConfigModal] = useState<boolean>(false);
  const [csvFoiEnviado, setCsvFoiEnviado] = useState<{ wasUpdated: boolean, isSuccess: boolean, details: any }>({ wasUpdated: false, isSuccess: false, details: "" });

  function handleSelectionChange(ids: GridSelectionModel) {
    setIdsSelecionados(ids);
  }

  function dateDifferenceInDays(dataRemessa: Date | null, dataRemessaEstatistica: Date | null, dataRecebimento: Date | null): number {

    if (!dataRemessa || !dataRemessaEstatistica)
      return 0;

    if (dataRecebimento && dataRecebimento.getTime() != -2208977612000) {
      return dataRemessa && dataRemessaEstatistica
        ? Math.floor((dataRecebimento.getTime() - dataRemessaEstatistica.getTime()) / (1000 * 60 * 60 * 24))
        : 0;
    } else {
      return dataRemessa && dataRemessaEstatistica
        ? Math.floor((dataRemessa.getTime() - dataRemessaEstatistica.getTime()) / (1000 * 60 * 60 * 24))
        : 0;
    }

  }

  function calculatePrevisaoEntrada(eta: Date | null): Date {
    const date = new Date();
    if (eta) {
      date.setTime(eta.getTime());
    }
    date.setDate(date.getDate() + 12);
    return date;
  }

  const calculateWeekOfMonth = (date: Date): number => {
    if (date) {
      const firstDay =
        new Date(date.getFullYear(), date.getMonth(), 1).getDay() + 1;
      return Math.ceil((date.getDate() + (firstDay - 1)) / 7);
    }

    return 0;
  };

  const getIsoWeek = (date: Date) => {
    let dateIso = new Date(date);
    dateIso.setHours(0, 0, 0, 0);
    dateIso.setDate(dateIso.getDate() + 3 - (dateIso.getDay() + 6) % 7);
    var week1 = new Date(dateIso.getFullYear(), 0, 4);
    return 1 + Math.round(((dateIso.getTime() - week1.getTime()) / 86400000
      - 3 + (week1.getDay() + 6) % 7) / 7);
  }

  function createData(pedidoImportacao: PedidoImportacao): Data {
    let etd: Date | null = pedidoImportacao.etd ? new Date(pedidoImportacao.etd) : null;
    let eta: Date | null = pedidoImportacao.eta ? new Date(pedidoImportacao.eta) : null;
    let dataRemessa: Date | null = pedidoImportacao.dataRemessa ? new Date(pedidoImportacao.dataRemessa) : null;
    let dataRemessaEstatistica: Date | null = pedidoImportacao.dataRemessaEstatistica ? new Date(pedidoImportacao.dataRemessaEstatistica) : null;
    let entradaEstoque: Date | null = pedidoImportacao.entradaEstoque ? new Date(pedidoImportacao.entradaEstoque) : null;
    let dataRegistroDes: Date | null = pedidoImportacao.dataRegistroDes ? new Date(pedidoImportacao.dataRegistroDes) : null;
    let previsaoEntradaEstoque: Date | null = pedidoImportacao.previsaoEntradaEstoque && false ? new Date(pedidoImportacao.previsaoEntradaEstoque) : calculatePrevisaoEntrada(eta);


    let mes = entradaEstoque || dataRemessa ? entradaEstoque ? entradaEstoque.getMonth() + 1 : (dataRemessa?.getMonth() ?? 0) + 1 : null;
    let semana = entradaEstoque || dataRemessa ? entradaEstoque ? getIsoWeek(entradaEstoque) : getIsoWeek(dataRemessa ?? new Date()) : null;

    if (!pedidoImportacao.bloqueadoLiberado) {
      pedidoImportacao.bloqueadoLiberado = "";
    }
    if (!pedidoImportacao.pedidoEncerrado) {
      pedidoImportacao.pedidoEncerrado = "";
    }
    return {
      id: pedidoImportacao.id,
      bookingStatus: pedidoImportacao.bookingStatus,
      sequenciaInstrucaoEmbarque: pedidoImportacao.sequenciaInstrucaoEmbarque,
      sequenciaDoEmbarque: pedidoImportacao.sequenciaDoEmbarque,
      documentoCompra: pedidoImportacao.documentoCompra,
      item: pedidoImportacao.item,
      codigoFornecedorSap: pedidoImportacao.codigoFornecedorSap,
      nomeFornecedorSap: pedidoImportacao.codigoFornecedorSap
        ? montaNomeFornecedor(pedidoImportacao.codigoFornecedorSap)
        : "",
      idSku: pedidoImportacao.idSku,
      skuDescricao: pedidoImportacao.descricaoSku,
      quantidadePedido: pedidoImportacao.quantidadePedido,
      quantidadeEmbarque: pedidoImportacao.quantidadeEmbarque,
      unidadeMedida: pedidoImportacao.unidadeMedida,
      dataRemessaEstatistica,
      dataRemessa,
      etd,
      eta,
      entradaEstoque,
      dataRegistroDes,
      previsaoEntradaEstoque,
      mes,
      semana,
      desvioRecebimento:
        pedidoImportacao.desvioRecebimento && false
          ? pedidoImportacao.desvioRecebimento
          : dateDifferenceInDays(dataRemessa, dataRemessaEstatistica, entradaEstoque),
      justificativa: pedidoImportacao.justificativa,
      justificativaDescricao: pedidoImportacao.justificativa,
      causador: pedidoImportacao.causador,
      observacao: pedidoImportacao.observacao,
      sigla: pedidoImportacao.siglaSku
    };
  }

  React.useEffect(() => {
    Utils.setDocumentTitle(t("pages.importRequest.pageTitle"));
    setLoading(true);
    setColumnVisibilityModel({
      // justificativa: false
    });
    let codigoFornecedorSap: number = 0;
    if (hasInCache("CodigoFornecedorSAPSelecionado")) {
      codigoFornecedorSap = Number.parseInt(
        String(localStorage.getItem("CodigoFornecedorSAPSelecionado"))
      );
      dataPedidoImportacao
        .ListarAtivosPorCodFornecedorSap(codigoFornecedorSap)
        .then((result) => {
          setPedidosImportacao(result);
        })
        .catch((erro) => {
          Mensagem(
            `${t("common.error")}`,
            `${t("pages.importRequest.text.unableToRecoverDate")}` +
            erro
          );
          setLoading(false);
        });
    } else {
      console.log(t("pages.importRequest.text.requiredSelectedPartner"));
    }
    setLoading(false);
  }, []);

  React.useEffect(() => {
    if (pedidosImportacao) {
      setRows(
        pedidosImportacao.map((pedidoImportacao: PedidoImportacao) => {
          if (pedidoImportacao && !pedidoImportacao.organizacaoCompra) {
            pedidoImportacao.organizacaoCompra = "";
          }
          return createData(pedidoImportacao);
        }
        )
      );
    }
  }, [pedidosImportacao]);

  useEffect(() => {
    if (csvFoiEnviado.wasUpdated) {
      setOpenFileDialog(false);
      if (csvFoiEnviado.isSuccess) {
        confirmAlert({
          title: t("pages.importRequest.pageTitle"),
          message: t("pages.importRequest.text.dataSavedSuccessfully"),
          buttons: [
            {
              label: t("common.ok"),
              onClick: () => {
                filtrar();
              },
            },
          ],
        })
      } else {
        confirmAlert({
          title: t("pages.importRequest.text.errorProcessingFile"),
          message: csvFoiEnviado.details.response.data,
          buttons: [
            {
              label: t("common.ok"),
              onClick: () => {
                filtrar();
              },
            },
          ],
        })
      }
    }
  }, [csvFoiEnviado]);

  function dateFormat(date: Date): string {
    return date && date.getFullYear() !== 1900 ? date.toLocaleDateString("pt-BR") : '';
  }

  function round3(value: number) {
    return value ? stripZeros(value.toFixed(3)) : 0;
  }

  function stripZeros(str: string) {
    return parseFloat(str.replace(",", ".")).toString().replace(".", ",");
  }

  const rowToPedidoImportacao = (id: number, usuarioIntegradorId: number) => {
    const pedidoImportacao: PedidoImportacao | undefined =
      pedidosImportacao.find((f) => f.id === Number(id));

    if (!pedidoImportacao) return undefined;

    const row: Data | undefined = rows.find((f) => f.id === pedidoImportacao.id);
    if (row?.justificativa) {
      pedidoImportacao.justificativa = row.justificativa.trim();
    }

    if (row?.causador) {
      pedidoImportacao.causador = row.causador.trim();
    }

    if (row?.observacao) {
      pedidoImportacao.observacao = row.observacao.trim();
    }

    if (row?.dataRemessa) {
      pedidoImportacao.dataRemessa = row.dataRemessa;
    }

    pedidoImportacao.usuarioIntegradorId = usuarioIntegradorId;

    return pedidoImportacao;
  }

  const handleClickSaveAll = () => {

    setLoading(true);

    let usuarioLogado: Usuario = JSON.parse(String(localStorage.getItem(dataUsuario.getKeyCach())));
    let pedidosImportacaoSalvar = rows.map((row: any) => rowToPedidoImportacao(row.id, +usuarioLogado.id));

    dataPedidoImportacao.AtualizarLote(pedidosImportacaoSalvar).then((result) => {
      if (result) {
        Mensagem(t("common.warning"), t("pages.importRequest.text.ordersUpdatedSuccessfully"), true);
      } else {
        Mensagem(t("common.error"), t("pages.importRequest.text.errorSavingOrders"), true);
      }
    }).finally(() => {
      setLoading(false);
    });
  }

  const handleClick = (cellValues: any) => {
    if (cellValues.field === "saveico" && !user.isSuporte) {
      let usuarioLogado: Usuario = JSON.parse(String(localStorage.getItem(dataUsuario.getKeyCach())));
      const pedidoImportacao: PedidoImportacao | undefined = rowToPedidoImportacao(cellValues.row.id, +usuarioLogado.id);

      if (pedidoImportacao) {
        setLoading(true);
        dataPedidoImportacao.Atualizar(pedidoImportacao).then((result) => {
          if (result) {
            Mensagem(t("common.warning"), t("pages.importRequest.text.orderUpdatedSuccessfully"), true);
          } else {
            Mensagem(t("common.error"), t("pages.importRequest.text.errorSavingOrder"), true);
          }
        }).finally(() => setLoading(false));
      }
    }
  };

  const columns: GridColumns = [
    {
      field: "id",
      headerName: "#",
      type: "string",
      width: 120,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "bookingStatus",
      headerName: t("common.statusBooking"),
      type: "string",
      width: 180,
      headerAlign: "center",
      align: "center",
      editable: false,
      renderCell: (e) => {
        return e.row.bookingStatus ? e.row.bookingStatus : t("common.canceled")
      }
    },
    {
      field: "sequenciaInstrucaoEmbarque",
      headerName: t("pages.importRequest.text.boardingInstructionSequenceNumber"),
      type: "string",
      width: 180,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "sequenciaDoEmbarque",
      headerName: t("pages.importRequest.text.boardingSequenceNo"),
      type: "string",
      width: 180,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "documentoCompra",
      headerName: t("pages.importRequest.text.purchasingDocument"),
      type: "string",
      width: 180,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "item",
      headerName: t("pages.importRequest.text.item"),
      type: "number",
      width: 80,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "codigoFornecedorSap",
      headerName: t("pages.importRequest.text.supplier"),
      type: "number",
      width: 120,
      headerAlign: "center",
      align: "center",
      editable: false,
      valueFormatter: (params) => round3(params.value),
    },
    {
      field: "nomeFornecedorSap",
      headerName: t("pages.importRequest.text.name"),
      type: "string",
      width: 180,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "idSku",
      headerName: t("pages.importRequest.text.materialPo"),
      type: "number",
      width: 180,
      headerAlign: "center",
      align: "center",
      editable: false,
      valueFormatter: (params) => round3(params.value),
    },
    {
      field: "sigla",
      headerName: t("pages.importRequest.text.acronym"),
      type: "string",
      width: 190,
      headerAlign: "center",
      align: "center",
      editable: false
    },
    {
      field: "skuDescricao",
      headerName: t("pages.importRequest.text.description"),
      type: "string",
      width: 300,
      headerAlign: "center",
      align: "center",
      editable: false,
      renderCell: (params) => (
        <SkuDescricao value={params.value} />
      ),
    },
    {
      field: "quantidadePedido",
      headerName: t("pages.importRequest.text.orderQuantity"),
      type: "number",
      width: 180,
      headerAlign: "center",
      align: "center",
      editable: false,
      valueFormatter: (params) => round3(params.value),
    },
    {
      field: "quantidadeEmbarque",
      headerName: t("pages.importRequest.text.shipmentQuantity"),
      type: "number",
      width: 180,
      headerAlign: "center",
      align: "center",
      editable: false,
      valueFormatter: (params) => round3(params.value),
    },
    {
      field: "etd",
      headerName: t("pages.importRequest.text.etd"),
      type: "string",
      width: 120,
      headerAlign: "center",
      align: "center",
      editable: false,
      valueFormatter: (params) => {
        return params.value ? dateFormat(params.value) : "";
      },
    },
    {
      field: "eta",
      headerName: t("pages.importRequest.text.eta"),
      type: "string",
      width: 150,
      headerAlign: "center",
      align: "center",
      editable: false,
      valueFormatter: (params) => {
        return params.value ? dateFormat(params.value) : "";
      },
    },
    {
      field: "dataRemessa",
      headerName: t("pages.importRequest.text.shippingDate"),
      type: "date",
      width: 150,
      headerAlign: "center",
      align: "center",
      editable: true
    },
    {
      field: "dataRemessaEstatistica",
      headerName: t("pages.importRequest.text.estatiscalShippingDate"),
      type: "string",
      width: 150,
      headerAlign: "center",
      align: "center",
      editable: false,
      valueFormatter: (params) => {
        return params.value ? dateFormat(params.value) : "";
      },
    },

    {
      field: "entradaEstoque",
      headerName: t("pages.importRequest.text.commodityReceiptDate"),
      type: "string",
      width: 150,
      headerAlign: "center",
      align: "center",
      editable: false,
      valueFormatter: (params) => {
        return params.value ? dateFormat(params.value) : "";
      },
    },
    {
      field: "dataRegistroDes",
      headerName: t("pages.importRequest.text.registrationDate"),
      type: "string",
      width: 150,
      headerAlign: "center",
      align: "center",
      editable: false,
      valueFormatter: (params) => {
        return params.value ? dateFormat(params.value) : "";
      },
    },
    {
      field: "mes",
      headerName: t("pages.importRequest.text.month"),
      type: "number",
      width: 120,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "semana",
      headerName: t("pages.importRequest.text.week"),
      type: "number",
      width: 120,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "desvioRecebimento",
      headerName: t("pages.importRequest.text.deviationReceiving"),
      type: "number",
      width: 120,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "justificativa",
      headerName: t("pages.importRequest.text.justify"),
      type: "string",
      width: 240,
      headerAlign: "center",
      align: "center",
      editable: true,
      renderEditCell: (gridItem) => {
        return <AutocompleteJustificativaCommon gridItem={gridItem} tipo={"Pedido"} />
      },
    },
    {
      field: "causador",
      headerName: t("pages.importRequest.text.causer"),
      type: "string",
      width: 240,
      headerAlign: "center",
      align: "center",
      editable: true,
      renderEditCell: (gridItem) => {
        return <AutocompleteJustificativaCommon gridItem={gridItem} tipo={"Causador"} />
      },
    },
    {
      field: "observacao",
      headerName: t("pages.importRequest.text.observation"),
      type: "string",
      width: 200,
      headerAlign: "center",
      align: "center",
      editable: true,
      renderCell: (item) => {
        return (
          <Tooltip style={{ cursor: 'pointer' }} title={item.row.observacao}>
            <span>
              {item.row.observacao}
            </span>
          </Tooltip>
        );
      }
    },
    {
      field: "saveico",
      headerName: "",
      width: 50,
      sortable: false,
      align: "center",
      editable: false,
      renderCell: () => {
        return (
          <Tooltip title="Salvar">
            <span>
              <IconButton disabled={user.isSuporte}>
                {" "}
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        );
      },
    },
  ];

  const Mensagem = (
    titulo: string,
    mensagem: string,
    refresh: boolean = true
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.ok"),
          onClick: () => {
            setOpen(false);
            if (refresh) {
              PageHelper.refreshPage();
            }
          },
        },
      ],
    });
  };

  function montaNomeFornecedor(codFornecedor: number): string {
    const parceiroSelecionadoCache: string = String(
      localStorage.getItem("ParceiroSelecionado")
    );
    if (parceiroSelecionadoCache && parceiroSelecionadoCache !== 'undefined') {
      const parceiro: Parceiro = JSON.parse(parceiroSelecionadoCache);
      if (parceiro) {
        return String(parceiro.nome);
      }
    }
    return "";
  }

  const integrarPedidos = () => {
    let valid = true;
    const pedidosSelecionados: Data[] = rows.filter((f) =>
      idsSelecionados.includes(f.id as number)
    );

    if (valid) {
      setLoading(true);
      if (pedidosSelecionados && pedidosSelecionados.length > 0) {
        let usuarioLogado: Usuario = JSON.parse(String(localStorage.getItem(dataUsuario.getKeyCach())));
        const pedidosParaIntegrar: PedidoImportacao[] = [];
        pedidosSelecionados.forEach((data) => {
          // const data: Data | undefined = rows.find((f) => f.id === pedido.id);
          const pedido = pedidosImportacao.find((f) => f.id === data.id);
          if (pedido) {
            pedido.desvioRecebimento = data.desvioRecebimento;
            pedido.previsaoEntradaEstoque = data.previsaoEntradaEstoque;
            pedido.dataRemessa = data.dataRemessa ?? new Date();
            pedido.mes = data.mes ?? 0;
            pedido.semana = data.semana ?? 0;
            if (data.justificativa) {
              pedido.justificativa = data.justificativa;
            }
            if (data.causador) {
              pedido.causador = data.causador;
            }
            if (data.observacao) {
              pedido.observacao = data.observacao;
            }
            pedido.usuarioIntegradorId = +usuarioLogado.id;
            pedidosParaIntegrar.push(pedido);
          }
        });

        dataPedidoImportacao
          .Integrar(pedidosParaIntegrar)
          .then((result) => {
            setLoading(false);
            if (result) {
              Mensagem(t("common.warning"), t("pages.importRequest.text.orderIntegratedSuccessfully"), true);
            } else {
              Mensagem(t("common.error"), t("pages.importRequest.text.errorInIntegration"), true);
            }
          })
          .catch((erro) => {
            setLoading(false);
            console.log(erro);
            Mensagem(t("common.error"), t("pages.importRequest.text.errorInIntegration"), true);
          });
      }
    } else {
      Mensagem(
        t("common.error"),
        t("pages.importRequest.text.justifyRequest"),
        false
      );
    }
  };

  const handleFilterChange =
    (param: keyof PedidosImportacaoFilters) =>
      (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilterValues((filters) => {
          return { ...filters, [param]: event.target.value };
        });
      };

  const resetar = () => {
    PageHelper.refreshPage();
  };

  const filtrar = () => {
    if (
      filterValues &&
      (filterValues.bookingStatus ||
        filterValues.pedido ||
        filterValues.material ||
        filterValues.instrucaoEmbarque)
    ) {
      setLoading(true);
      let codigoFornecedorSap: number = 0;
      if (hasInCache("CodigoFornecedorSAPSelecionado")) {
        codigoFornecedorSap = Number.parseInt(
          String(localStorage.getItem("CodigoFornecedorSAPSelecionado"))
        );
        dataPedidoImportacao
          .ListarAtivosPorCodFornecedorSap(codigoFornecedorSap)
          .then((result) => {
            if (result) {
              if (filterValues.bookingStatus) {
                result = result.filter(
                  (f) => f.bookingStatus === filterValues.bookingStatus
                );
              }
              if (filterValues.pedido) {
                result = result.filter(
                  (f) => f.id === Number(filterValues.pedido)
                );
              }
              if (filterValues.material) {
                result = result.filter(
                  (f) => f.idSku === Number(filterValues.material)
                );
              }
              if (filterValues.instrucaoEmbarque) {
                result = result.filter(
                  (f) =>
                    f.sequenciaInstrucaoEmbarque ===
                    filterValues.instrucaoEmbarque
                );
              }

              setPedidosImportacao(result);
            }
          })
          .catch((erro) => {
            Mensagem(
              t("common.error"),
              `${t("pages.importRequest.text.unableToRecoverDate")}` +
              erro
            );
            setLoading(false);
          });
      } else {
        console.log(t("pages.importRequest.text.requiredSelectedPartner"));
      }
      setLoading(false);
    } else {
      PageHelper.refreshPage();
    }

    setFilterOpen(false);
  };

  const onCellEditCommit = (params: GridCellEditCommitParams, _event: MuiEvent<MuiBaseEvent>) => {
    const rowIndex = pedidosImportacao.findIndex(row => row.id === params.id);
    if (rowIndex >= 0) {
      const row = pedidosImportacao[rowIndex] as any;
      if (params.field in row && row[params.field] !== params.value) {
        const tempList = [...pedidosImportacao] as any;
        if (params.field === 'justificativa') {
          tempList[rowIndex][params.field] = params.value ? params.value.trim() : params.value;
        } else {
          tempList[rowIndex][params.field] = params.value;
        }
        setPedidosImportacao(tempList);
      }
    }
  }

  function handleClickHistoricoPedidoImportacao() {
    setOpenModal(true);
  }

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  const handleCloseDownloadCSVModal = () => {
    setOpenDownloadCSVModal(false);
  }

  const handleClickOpenUploadCSV = () => {
    setOpenFileDialog(true);
  }

  const handleClickCloseUploadCSV = () => {
    setOpenFileDialog(false);
  };

  const FileUploadPage = () => {

    var codigoFornecedorSap = Number.parseInt(
      String(localStorage.getItem("CodigoFornecedorSAPSelecionado"))
    );

    return (
      <div>
        <FileUpload {...{ endpoint: `PedidoImportacao/ProcessarPlanilha/${codigoFornecedorSap}`, setCsvFoiEnviado: setCsvFoiEnviado, apiName: "Pedidos" }} />
      </div >
    )
  }

  return (
    <div className={`container ${styles.container}`}>
      <div className="containerTitle">
        <PedidosImportacaoTopo {...{ title: t("pages.importRequest.pageTitle") }} />
      </div>
      <div className="containerToolbar">
        <Tooltip title={t("pages.importRequest.text.saveAllLines")}>
          <span>
            <IconButton onClick={handleClickSaveAll}
              disabled={loading || user.isSuporte}>
              <SaveIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={t("pages.importRequest.text.csvDownload")}>
          <span>
            <IconButton onClick={handleClickOpenDownloadCSV} >
              <Download />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={t("pages.importRequest.text.loadCsvFile")}>
          <span>
            <IconButton onClick={handleClickOpenUploadCSV} >
              <FileUploadIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={t("pages.importRequest.text.watchOrderHistory")}>
          <span>
            <IconButton onClick={handleClickHistoricoPedidoImportacao} disabled={loading || user.isSuporte}>
              <CalendarMonthIcon />
            </IconButton>
          </span>
        </Tooltip>
        <React.Fragment>
          <Tooltip title={t("pages.importRequest.text.filter")}>
            <span>
              <IconButton
                onClick={() => setFilterOpen(true)}
                disabled={loading}
              >
                <FilterAltIcon />
              </IconButton>
            </span>
          </Tooltip>
        </React.Fragment>
        <React.Fragment>
          <Tooltip title={t("pages.importRequest.text.sapIntegrate")}>
            <span>
              <IconButton
                onClick={integrarPedidos}
                disabled={!hasIdSelecionado || loading || user.isSuporte}
              >
                <ShareIcon />
              </IconButton>
            </span>
          </Tooltip>
        </React.Fragment>
        <React.Fragment>
          <Tooltip title={t("pages.importRequest.text.config")}>
            <span>
              <IconButton
                onClick={() => setShowConfigModal(true)}
                disabled={loading || user.isSuporte}
              >
                <SettingsIcon />
              </IconButton>
            </span>
          </Tooltip>
        </React.Fragment>
      </div>
      <div className={`gridScroll ${styles.table}`}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            columnVisibilityModel={columnVisibilityModel}
            rowsPerPageOptions={[50, 100, 250, 500]}
            // experimentalFeatures={{ newEditingApi: true }}
            key="PedidoImportacaoGrid"
            // rowHeight={35}
            onCellClick={(cellValues) => handleClick(cellValues)}
            checkboxSelection={!user.isSuporte}
            disableSelectionOnClick
            onSelectionModelChange={(id) => {
              handleSelectionChange(id);
            }}
            onCellEditCommit={onCellEditCommit}
          />
        </LocalizationProvider>
      </div>
      <div>
        <Dialog
          open={filterOpen}
          onClose={() => setFilterOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="filterPI"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.importRequest.text.filterImportOrders")}
            <br />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <br />
              <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-pedido">
                  { }
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-pedido"
                  value={filterValues.pedido}
                  onChange={handleFilterChange("pedido")}
                  label={t("pages.importRequest.text.order")}
                />
              </FormControl>
              <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-bookingStatus">
                  {t("common.statusBooking")}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-bookingStatus"
                  value={filterValues.bookingStatus}
                  onChange={handleFilterChange("bookingStatus")}
                  label={t("common.statusBooking")}
                />
              </FormControl>
              <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-material">
                  {t("pages.importRequest.text.material")}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-material"
                  value={filterValues.material}
                  onChange={handleFilterChange("material")}
                  label={t("pages.importRequest.text.material")}
                />
              </FormControl>
              <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-instrucaoEmbarque">
                  {t("pages.importRequest.text.shippingInstruction")}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-instrucaoEmbarque"
                  value={filterValues.instrucaoEmbarque}
                  onChange={handleFilterChange("instrucaoEmbarque")}
                  label={t("pages.importRequest.text.shippingInstruction")}
                />
              </FormControl>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="primary"
              onClick={filtrar}
              autoFocus
            >
              {t("common.filter")}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={resetar}
              autoFocus
            >
              {t("common.reset")}
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={() => setFilterOpen(false)}
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        sx={{ "display": "flex", "justify-content": "center", "align-items": "center" }}
      >
        <HistoricoPedidoImportacaoModal handleClose={handleCloseModal} />
      </Modal>
      <Modal
        open={showConfigModal}
        onClose={() => setShowConfigModal(false)}
        sx={{ "display": "flex", "justify-content": "center", "align-items": "center" }}
      >
        <ConfigurationModal handleClose={() => setShowConfigModal(false)} />
      </Modal>
      <Modal
        open={openDownloadCSVModal}
        onClose={handleCloseDownloadCSVModal}
        sx={{
          display: "flex",
          "justifyContent": "center",
          "alignItems": "center",
        }}
      >
        <>
          <DownloadCSVModal
            handleClose={handleCloseDownloadCSVModal}
            rows={rows}
            columns={columns}
            name={t("pages.importRequest.pageTitle")}
          />
        </>
      </Modal>
      <div>
        <Dialog
          open={openFileDialog}
          onClose={handleClickCloseUploadCSV}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.importRequest.text.sheetImport")}
            <br />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"><br />
              {FileUploadPage()}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="success"
              onClick={handleClickCloseUploadCSV}
              autoFocus
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

export default PedidosImportacao;
